import { useEffect, useRef } from 'react';
import { useEscapeKey } from './useEscapeKey';

export const useDismissOnOutside = (containerRef, isActive, onDismiss, extraRefs = []) => {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEscapeKey(() => onDismissRef.current(), isActive);

  useEffect(() => {
    if (!isActive) return undefined;

    const handleClickOutside = (event) => {
      const inside = [containerRef, ...extraRefs].some((ref) => ref.current?.contains(event.target));
      if (containerRef.current && !inside) {
        onDismissRef.current();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [containerRef, isActive, extraRefs]);
};

export default useDismissOnOutside;
